'use client'
import {
  commonWhere
} from "./chunk-N55STAST.mjs";
import {
  getContentfulSafeLocale
} from "./chunk-IIMDQLWJ.mjs";
import {
  ContentfulConfig
} from "./chunk-4T365VQK.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/api/explore/listing.ts
import { useInfiniteQuery } from "@tanstack/react-query";
import { Exception } from "@wbk/logger";
var getExplore = (props) => __async(null, null, function* () {
  var _a;
  try {
    const cdnBase = (_a = ContentfulConfig.config) == null ? void 0 : _a.base;
    const _b = props, { search } = _b, variables = __objRest(_b, ["search"]);
    const data = yield fetch(`${cdnBase}/explore`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(__spreadProps(__spreadValues({}, search ? { search } : {}), {
        variables: __spreadProps(__spreadValues({
          order: "order_ASC"
        }, variables), {
          lang: getContentfulSafeLocale(variables.lang),
          where: __spreadValues(__spreadValues({}, commonWhere), variables.where)
        })
      }))
    });
    const json = yield data.json();
    return json;
  } catch (error) {
    throw new Exception({ error, name: "getExploreException" });
  }
});
var useGetExplore = (props, options) => {
  const perPage = props.limit || 7;
  return useInfiniteQuery(__spreadValues({
    queryKey: ["getExplore", props],
    initialPageParam: 1,
    queryFn: ({ pageParam }) => getExplore(__spreadProps(__spreadValues({}, props), { skip: (pageParam - 1) * perPage })),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const totalRendered = lastPageParam * perPage;
      const total = lastPage.total;
      return total > totalRendered ? lastPageParam + 1 : void 0;
    },
    refetchOnMount: false,
    select: (data) => {
      var _a, _b;
      const pages = data.pages;
      const total = ((_a = pages == null ? void 0 : pages[0]) == null ? void 0 : _a.total) || 0;
      const maxPrice = ((_b = pages == null ? void 0 : pages[0]) == null ? void 0 : _b.maxPrice) || 0;
      return { total, maxPrice, data: data.pages.flatMap((page) => page.data) };
    }
  }, options));
};

export {
  useGetExplore
};
//# sourceMappingURL=chunk-HATK644S.mjs.map